module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "empty-state",
    attrs: {
      "role": "status"
    }
  }, [_c('svg', {
    staticClass: "empty-illustration",
    attrs: {
      "viewBox": "0 0 120 88",
      "fill": "none",
      "aria-hidden": "true",
      "focusable": "false"
    }
  }, [_c('ellipse', {
    attrs: {
      "cx": "61",
      "cy": "77",
      "rx": "32",
      "ry": "4",
      "fill": "#f1f4f7"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "28",
      "y": "14",
      "width": "49",
      "height": "54",
      "rx": "7",
      "transform": "rotate(-10 52.5 41)",
      "fill": "#f5f7fa",
      "stroke": "#e1e6ed",
      "stroke-width": "1.5"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "42",
      "y": "23",
      "width": "49",
      "height": "49",
      "rx": "7",
      "fill": "#fff",
      "stroke": "#d9e0e8",
      "stroke-width": "1.5"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M54 37h15M54 47h25M54 57h18",
      "stroke": "#e1e6ed",
      "stroke-width": "3",
      "stroke-linecap": "round"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "empty-accent",
    attrs: {
      "x": "75",
      "y": "23",
      "width": "8",
      "height": "3",
      "rx": "1.5"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "empty-title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), (_vm.description) ? _c('p', {
    staticClass: "empty-description"
  }, [_vm._v(_vm._s(_vm.description))]) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-232a49f1", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-232a49f1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/element/emptyState.vue
// module id = 1032
// module chunks = 30